import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from '@/store/auth';
import { useDogspace } from '@/store/dogspaces';
import { Documents, Dogspaces } from '@busy-human/k9-library';
import { computed, reactive, ref } from 'vue';
import { ZodFirstPartyTypeKind, ZodString, ZodNumber, z } from "zod";
import VaccineDownload from './vaccine-download.vue';


type Props = {
    editDog?: string
    inline?: boolean
}
type Emits = {
    (e:'close'):void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'dog-creator',
  props: {
    editDog: {},
    inline: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;


const auth = useAuth();
const dogStore = useDogspace();
const dogDetails = reactive<Dogspaces.Model>(props.editDog ? { ...dogStore.dogs[props.editDog] } : { ...Dogspaces.Defaults(), owner: auth.currentUid! })
const image = ref<File | null>(null);
const vaxFiles = ref<{[T in Documents.VAXDOCTYPE]?: File}>({});
const vaxExp = reactive<{[T in Documents.VAXDOCTYPE]?: string}>({});

const emit = __emit;

const dogValidation = computed(() => Dogspaces.Schema.safeParse(dogDetails));

const loading = ref(false);

function handleVax(list: FileList, vax: Documents.VAXDOCTYPE) {
    const tmp = list.item(0)
    if(tmp)
        vaxFiles.value[vax] = tmp;
    // console.log(tmp);
}

function vaxExpired(vax: z.infer<typeof Dogspaces.VaccineRefSchema>) {
    if(!vax) return false;
    return new Date(vax.expires).getTime() < new Date().getTime();
}

const vaccinesReady = computed(() => {
    for(const key in vaxFiles.value) {
        if(!vaxExp[key as Documents.VAXDOCTYPE]) return false;
    }
    return true;
})

const __returned__ = { props, auth, dogStore, dogDetails, image, vaxFiles, vaxExp, emit, dogValidation, loading, handleVax, vaxExpired, vaccinesReady, get useAuth() { return useAuth }, get useDogspace() { return useDogspace }, get Documents() { return Documents }, get Dogspaces() { return Dogspaces }, computed, reactive, ref, get ZodFirstPartyTypeKind() { return ZodFirstPartyTypeKind }, get ZodString() { return ZodString }, get ZodNumber() { return ZodNumber }, get z() { return z }, VaccineDownload }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})